import { Flex } from '@chakra-ui/react';
import React from 'react';
import { PageHeader } from './components/PageHeader';
import { UI } from './components/UI';

export const VerifyAccreditationSuccessPage: React.FC = () => {
  return (
    <UI>
      <Flex px={[6, 20]} pt={['24px', '56px']} pb={[20, 200]} direction={'column'} gap={10} align="center">
        <PageHeader
          title="Success"
          subtitle="Thanks, we recorded your information relating to accreditation. You may close this window"
          icon="check"
          iconColorScheme="green"
        />
      </Flex>
    </UI>
  );
};
